<template>
  <v-card class="mb-4 position-relative overflow-hidden">
    <!-- Sparkline positioned absolutely to appear behind content -->
    <div
      v-if="showSparkline && sparklineData && Array.isArray(sparklineData) && sparklineData.length > 1"
      class="position-absolute w-100"
      :style="`bottom: 0; left: 0; right: 0;`"
    >
      <v-sparkline
        class="w-100"
        :color="computedSparklineColor"
        fill
        :gradient="computedGradient"
        :height="sparklineHeight || 100"
        :line-width="sparklineLineWidth || 4"
        :min="sparklineMin || 0"
        :model-value="sparklineData.filter(v => typeof v === 'number' && !isNaN(v))"
        padding="0"
        :smooth="sparklineSmooth !== false"
      />
      <!-- X-axis labels positioned at the bottom but on top of sparkline -->
      <div
        v-if="sparklineLabels && sparklineLabels.length > 0"
        class="position-absolute w-100"
        style="bottom: 5px; left: 0; right: 0; padding: 0 4px; z-index: 2;"
      >
        <div class="position-relative w-100" style="height: 20px;">
          <template v-for="(label, index) in sparklineLabels" :key="index">
            <span
              v-if="label"
              class="text-caption text-medium-emphasis position-absolute"
              :style="labelStyle(index)"
            >
              {{ label }}
            </span>
          </template>
        </div>
      </div>
    </div>
    <!-- Content positioned relative to appear on top -->
    <div class="pa-4 position-relative" style="z-index: 1;">
      <div class="ps-4 text-body-1 text-medium-emphasis d-flex align-center justify-space-between" style="min-height: 24px;">
        {{ label }}
        <v-switch
          v-if="count > 0"
          class="ma-0 pa-0 custom-switch flex-shrink-0"
          v-model="localSelected"
          @change="handleSwitchChange"
          hide-details
          density="compact"
          color="secondary"
        ></v-switch>
      </div>

      <v-card-title class="pt-0 mt-n1 d-flex align-center">
        <div class="me-2 text-h2">{{ displayCount }}</div>

        <v-chip
          v-if="showPercentageChange && percentageChange !== null"
          class="pe-1"
          :color="chipColor"
          label
          :prepend-icon="`mdi-arrow-${percentageChange < 0 ? 'down' : 'up'}`"
          size="x-small"
        >
          <template #prepend>
            <v-icon size="10" />
          </template>

          <span class="text-caption">{{ Math.abs(percentageChange) }}%</span>
        </v-chip>

        <v-tooltip :text="tooltip" location="top" v-if="tooltip && tooltip.length > 0">
          <template v-slot:activator="{ props }">
            <v-icon
              v-bind="props"
              icon="mdi-information"
              size="small"
              class="ml-2"
            ></v-icon>
          </template>
        </v-tooltip>
      </v-card-title>
    </div>
  </v-card>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
